<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <CustomBreadcrumb :items="items_bread_crumb"  />
      <div class="card card-w-title">
        <div class="row manager-title-row">
          <div class="p-col-4 manager-title-custom">{{ title }}</div>
        </div>
        <!-- <div class="note">(*) Nội dung không được bỏ trống</div> -->
        <formEdit
          :key="componentKey"
          :mode="mode"
          @back="backToList"
          @save="saveData"
          :triggerSave.sync="triggerSave"
          :model="models"/>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import DataServices from '@/core/DataServices'
import formEdit from './add'
import gql from "graphql-tag";

import ApiRepository from "@/core/ApiRepository";
// import axios from "axios";
export default {
  components: {
    formEdit
  },
  data() {
    return {
      items_bread_crumb: [
        { label: 'Available For Rent', to: '/admin/list-available_for_rent' },
        { label: '' }
      ],
      users: null,
      validationErrors: [],
      title: "Create A New Post",
      mode: 'add',
      models: {},
      componentKey: 0,
      accountID: '',
      page_transaction:null,
      active_check:true,
      users_clubs_id : '',
      time_zone_local : moment.tz.guess(true),
      triggerSave: false
    }
  },
  async mounted () {
    console.log("this.$route.name:",this.$route.query.page_transaction);
    this.mode = this.$route.name === 'edit' ? 'edit' : this.mode;
    if (this.$route.params.id !== undefined) await this.getData(this.$route.params.id);
    this.title = this.mode === 'edit' ? `Edit ${this.models?.code}` : this.title;
    this.items_bread_crumb[1].label = this.title;

    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)){
        this.page_transaction = this.$route.query.page_transaction;
      }
    }
    //check quyền
    var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_AVAILABLE_FOR_RENT);
    if (this.mode == 'edit'){
      if (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }else {
      if (arr_role.indexOf(this.$constants.ROLE.ADD) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }
  },
  methods: {
    backToList() {
      this.$router.push({ path: '/admin/list-available_for_rent' });
    },
    UpdateActive(key){
      // console.log("key",key)
      var uid = this.$route.params.id;
      this.$commonFuction.is_loading(true);
      if(key == 'lock'){
        this.active_check = false
      }else{
        this.active_check = true
      }

      let variables = {
        'data_update': {
          'active': this.active_check
        },
        'where_key': {
          'id': {'_eq': this.$route.params.id}
        }
      };
      var that = this;
      this.$apollo.mutate({
        mutation: DataServices.updateData('users'),
        variables: variables
      }).then(async (res) => {
        console.log('Success',res);
        if(key == 'lock'){
          var query_t =  `mutation {
            delete_jwt_token(where: { uid: {_eq: "${uid}"}}) {
              returning {
                id
              }
            }
          }`
          await that.$apollo.mutate({
            mutation: gql(query_t),
          })
        }
        that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Save data successfully', life: 3000 })
      })
      this.$commonFuction.is_loading(false);
      // console.log("this.$route.params.id",this.$route.params.id)
    },
    async getLisVehicleCategorySlug(id_category) {
      try {
        var where_key = {
          deleted: { _eq: false },
          id: { _eq: id_category }
        };
        var list = await this.$CoreService.getLisVehicleCategory(where_key);
        console.log("listlistlistlist", list);
        if (list && list.list && list.list.length > 0) {
          return list.list[0].name; 
        }

        return null;
      } catch (error) {
        console.error('Error:', error);
        return null;
      }
    },
    // auto_in_number
    async getListAvailableForRent() {
      try {
        var where_key = {
          // deleted: { _eq: false }
        };
        var list = await this.$CoreService.getListAvailableForRent(where_key);
        if (list && list.list && list.list.length > 0) {
          const maxAutoInNumber = Math.max(...list.list.map(item => item.auto_in_number));
          return maxAutoInNumber;
        }
        return null;
      } catch (error) {
        console.error('Error:', error);
        return null;
      }
    },

    async saveData(params) {
      var objects = {};
      console.log(objects);
      
      console.log("params", params);
    

    
      const code_available_for_rent = await ApiRepository.post('/_api/car/generate_code_available_car_for_rent');
      var data_name = await this.getLisVehicleCategorySlug(params.vehicle_category_id);
      var nameConvertSlug = this.stringToSlug(data_name);
      var list_file = params?.list_file ?? [];
      var list_file_cover = params?.list_file_cover ?? [];
      var list_file_cover_edit = params?.list_file_cover_edit ?? [];
      var list_id_file_delete = params?.list_id_file_delete ?? [];
      var list_id_file_delete_cover = params?.list_id_file_delete_cover ?? [];
 
      var auto_in_number = await this.getListAvailableForRent();
      console.log("auto_in_number", auto_in_number);
      
      this.triggerSave = false;
      try {
        console.log('12');
        
        if (this.mode == 'add') {
          console.log("objects", objects);
          objects.created_at = moment.tz(new Date(), this.time_zone_local);
          objects.created_by = this.$store.getters.user;
          let res = await this.$apollo.mutate({
            mutation: DataServices.insertData('available_for_rent'),
            variables: {
              objects: {
                vehicle_category_id: params?.vehicle_category_id ?? '',
                description: params?.description ?? '',
                alt: params?.alt ?? '',
                new: params?.new ?? false,
                active: params?.active ?? true,
                updated_at: moment.tz(new Date(), this.time_zone_local),
                updated_by: this.$store.getters.user,
                slug: `${nameConvertSlug}-${auto_in_number + 1}`,
                code:code_available_for_rent?.data?.data?.code ?? null,
                auto_in_number : auto_in_number + 1,
                created_at : moment.tz(new Date(), this.time_zone_local),
                created_by : this.$store.getters.user
              }
            }
          });
          let returningCar = res.data[Object.keys(res.data)[0]].returning[0]; 
          console.log("returningCar", returningCar);
          try {
              await ApiRepository.post('/_api/sitemap/add_sitemap', {
              url: `rent/${nameConvertSlug}-${auto_in_number + 1}`,
              type: 'dynamic',
              obj_id: returningCar.id,
              priority: 0.5,
              changefreq: 'weekly',
              lastmod: moment.tz(new Date(), this.time_zone_local).format('YYYY-MM-DD HH:mm:ss'),
              uid_admin: this.$store.getters.user
            });
          } catch (error) {
            console.log('Error adding to sitemap:', error);
          }

              if (list_file_cover.length > 0) {
            let resImageCover = await this.$CoreService.uploadImages(this.$constants.FOLDER_S3.CAR_RENT_AVARTAR, list_file_cover);
            if (resImageCover && resImageCover.length > 0) {
              console.log("resImageCover", resImageCover);
              
                let objectImage = resImageCover[0];
                console.log("objectImage", objectImage);
                
                await this.$CoreService.updateDataImage(this.$constants.TYPE_IMAGE.CAR_RENT_AVARTAR, returningCar.id, objectImage).catch(async error => {
                  console.log('error', error);
                  this.$toast.add({
                    severity: 'error',
                    summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                    detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                    life: 3000
                  });
                });
            }
          }
          // Upload file nếu có
          if (list_file.length > 0) {
            let resImage = await this.$CoreService.uploadImages(this.$constants.FOLDER_S3.CAR_RENT_NORMAL, list_file);
            if (resImage && resImage.length > 0) {
              for (let i = 0; i < resImage.length; i++) {
                let objectImage = resImage[i];
                await this.$CoreService.updateDataImage(this.$constants.TYPE_IMAGE.CAR_RENT_NORMAL, returningCar.id, objectImage).catch(async error => {
                  console.log('error', error);
                  this.$toast.add({
                    severity: 'error',
                    summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                    detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                    life: 3000
                  });
                });
              }
            }
          }

          this.redirectEdit();
          
        } else {
          let variables = {
            'data_update': objects = {
              vehicle_category_id: params?.vehicle_category_id ?? '',
              description: params?.description ?? '',
              alt: params?.alt ?? '',
              new: params?.new ?? false,
              active: params?.active ?? true,
              updated_at: moment.tz(new Date(), this.time_zone_local),
              updated_by: this.$store.getters.user,
              slug: `${nameConvertSlug}-${params?.auto_in_number }`,
            },
            'where_key': {
              'id': { '_eq': this.models.id }
            }
          };
          await this.$apollo.mutate({
            mutation: DataServices.updateData('available_for_rent'),
            variables: variables
          });
          
          try {
              await ApiRepository.post('/_api/sitemap/add_sitemap', {
              url: `rent/${nameConvertSlug}-${params?.auto_in_number }`,
              type: 'dynamic',
              obj_id: this.models.id,
              priority: 0.5,
              changefreq: 'weekly',
              lastmod: moment.tz(new Date(), this.time_zone_local).format('YYYY-MM-DD HH:mm:ss'),
              uid_admin: this.$store.getters.user
            });
          } catch (error) {
            console.log('Error adding to sitemap:', error);
          }

          if (list_id_file_delete.length > 0) {
            await this.$CoreService.deleteDataImageMulti(this.$constants.TYPE_IMAGE.CAR_RENT_NORMAL, list_id_file_delete);
          }
    
          // Xử lý upload file
          if (list_file.length > 0) {
            const resImage = await this.$CoreService.uploadImages(this.$constants.FOLDER_S3.CAR_RENT_NORMAL, list_file);
            if (resImage && resImage.length > 0) {
              for (let i = 0; i < resImage.length; i++) {
                var objectImage = resImage[i];
                await this.$CoreService.updateDataImage(this.$constants.TYPE_IMAGE.CAR_RENT_NORMAL, this.models.id, objectImage).catch(async error => {
                  console.log('error', error);
                  this.$toast.add({
                    severity: 'error',
                    summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                    detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                    life: 3000
                  });
                });
              }
            }
          }
    
          if (list_id_file_delete_cover.length > 0) {
            await this.$CoreService.deleteDataImageMulti(this.$constants.TYPE_IMAGE.CAR_RENT_AVARTAR, list_id_file_delete_cover);
          }
    
          if (list_file_cover.length > 0) {
            if (list_file_cover_edit.length > 0) {
              await this.$CoreService.deleteDataImage(this.$constants.TYPE_IMAGE.CAR_RENT_AVARTAR, this.models.id);
            }
            const resCoverImage = await this.$CoreService.uploadImages(this.$constants.FOLDER_S3.CAR_RENT_AVARTAR, list_file_cover);
            if (resCoverImage && resCoverImage.length > 0) {
              for (let i = 0; i < resCoverImage.length; i++) {
                var coverImage = resCoverImage[i];
                await this.$CoreService.updateDataImage(this.$constants.TYPE_IMAGE.CAR_RENT_AVARTAR, this.models.id, coverImage).catch(async error => {
                  console.log('error', error);
                  this.$toast.add({
                    severity: 'error',
                    summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                    detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                    life: 3000
                  });
                });
              }
            }
          }
          this.redirectEdit();

        }
      } catch (error) {
        console.error('Error:', error);
        this.$toast.add({
          severity: 'error',
          summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
          detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
          life: 3000
        });
      } finally {
        this.$commonFuction.is_loading(false);
      }
    },
    stringToSlug(str) {
      return str
        .toLowerCase() 
        .trim() 
        .replace(/[\s\W-]+/g, '-')
        .replace(/^-+|-+$/g, '');
    },
    async redirectEdit() {
      var that = this;
      var router_back = {path: '/admin/list-available_for_rent'};
      console.log('router_back',router_back)
      that.$commonFuction.is_loading(false);
      if(that.mode == 'add'){
        that.$router.push(router_back);
      }else{
        if (!that.$commonFuction.isEmpty(router_back)){
          // that.page_transaction = ""+that.page_transaction
          router_back.query = { page_transaction: that.page_transaction.toString() };
        }
        that.$router.push(router_back);
      }
      that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Save data successfully', life: 3000 })
    },
    async getData(id) {
      var { data } = await this.$apollo.query({
        query: DataServices.getList('available_for_rent'),
        variables: {
          where_key: {
            id: { '_eq': id }
          }
        },
        fetchPolicy: "network-only"
      })
      console.log("datadata:", data);
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        this.models = model[0];
        var dataImage = await this.$CoreService.getFileMapFile([this.$constants.TYPE_IMAGE.CAR_RENT_AVARTAR], [this.models.id]);
        var dataImageList = await this.$CoreService.getFileMapFile([this.$constants.TYPE_IMAGE.CAR_RENT_NORMAL], [this.models.id]);

        this.models["list_file_edit"] = dataImage.listData;
        this.models["list_file_edit_normal"] = dataImageList.listData;
        console.log("this.models", this.models);
        
      }
      this.componentKey++;
    },
  },
  apollo: {
    
  }
}
</script>

<style lang="scss">
.manager-title-custom {
  color: #1D3118;
  font-size: 24px;
  /* margin-bottom: 16px; */
  padding-bottom: 10px;
  /* border-bottom: 1px solid #EEEEEE; */
  font-weight: 700;
  margin-left: 20px;
}
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only { padding: 0 !important; }
  }
}
.note{ letter-spacing: 0px; color: #707070; margin-bottom: 24px; padding-top: 10px;}
.p-formgrid { margin: 0;
  .p-panel-header {color: #000000; font-size: 18px; font-weight: bold; background: #EEEEEE;}
  .p-card-field{ padding: 24px;
    .p-field{
      .p-col-fixed { width: 300px; display: inline-block !important; margin: 0;}
      .p-col-width{width:500px !important; border-radius: 5px;
        &.disabled{background: #EEEEEE; border: 0 none; padding: 8px 10px;}
        .file-select{margin: 0;
          input[type="file"]{display: none;}
          .select-button{display: inline-block; cursor: pointer; background: transparent; border-radius: 5px;  color: #000000; font-size: 13px; padding: 3px 16px;  border: 1px solid #B4B4B4;}
        }
        &.pac-target-input{ height: 80px;  word-break: break-all; overflow-wrap: break-word;  resize: none;}
      }
      .box-images{ margin: 0; margin-top: 10px; position: relative;
        .item-img{width: 150px; height: 150px;  margin-right: 8px; margin-bottom: 8px; display: inline-flex; position: relative;
          img{max-width: 100%; height: auto;margin: 0 auto; object-fit: contain; padding: 5px;}
          .button-clear{border-radius: 10px; width: 24px; height: 24px; background: #F5564E; float: right; cursor: pointer; position: absolute; right: 0px;
            img{vertical-align: top;}
          }
        }
      }
      .p-invalid{display: block;}
    }
  }
  .fixed-bottom-toolbar{background: transparent; border: 0 none; margin-top: 22px; border-top: 1px solid #B4B4B4; padding: 0; padding-top: 30px;
    .p-button{width: auto; margin-right: 8px;
      &:last-child{margin-right: 0;}
    }
  }
}
.manager-title-row{
  border-bottom: 1px solid #EEEEEE;
}
.p-toolbar-group-right {
  flex-basis: 30%;
}
.p-button-warning.p-button {
  margin: 0 10px;
}
</style>